/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TCheckEstimationExistsRequest,
  TCheckEstimationExistsModel,
  IMappers,
  TCheckEstimationExistsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IEstimationExistsResponse } from '../../entities/estimation/EstimationExistsResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createCheckEstimationExistsModel(
  parameters: TCheckEstimationExistsRequest,
): TCheckEstimationExistsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'price-estimator',
    pathApi: '/v1/check-estimation-exists/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ICheckEstimationExistsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TCheckEstimationExistsRequest;
}

export async function fetchCheckEstimationExists<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICheckEstimationExistsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCheckEstimationExistsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCheckEstimationExistsModel(parameters),
    config,
  )) as FetchResponse<TCheckEstimationExistsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IEstimationExistsResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCheckEstimationExistsResponse>;
}
